"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _formValidations = require("../../../helpers/formValidations");
var _SendAddressContainer = _interopRequireDefault(require("../SendAddress/SendAddressContainer"));
var _VerificationRequiredContainer = _interopRequireDefault(require("../../VerificationRequired/VerificationRequiredContainer"));
var _APNumberInput = _interopRequireDefault(require("../../common/APNumberInput"));
var _APInput = _interopRequireDefault(require("../../common/APInput"));
var _APButton = _interopRequireDefault(require("../../common/APButton"));
var _APLabelWithText = _interopRequireDefault(require("../../common/APLabelWithText"));
var _sendReceiveComponent = require("../../../propTypes/sendReceiveComponent");
require("./SendForm.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('send-form');
var allowedAmountValuesRange = (0, _formValidations.allowedNumberValuesRange)('0', '79228162514264337593543950335');
var SendForm = /*#__PURE__*/function (_React$Component) {
  function SendForm() {
    var _this;
    _classCallCheck(this, SendForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SendForm, [].concat(args));
    _defineProperty(_this, "lessThanBalance", function (value) {
      var t = _this.props.t;
      var balance = _this.props.balance;
      if (balance === 0) return t('0 balance available');
      return (0, _formValidations.lessThanValue)(balance, value);
    });
    _defineProperty(_this, "checkUserEmail", function (value) {
      var userEmail = _this.props.userEmail;
      return (0, _formValidations.validateReceiverEmail)(value, userEmail);
    });
    return _this;
  }
  _inherits(SendForm, _React$Component);
  return _createClass(SendForm, [{
    key: "render",
    value:
    // componentWillReceiveProps(nextProps) {
    //   const nextAmount = nextProps.Amount;
    //   const Amount = this.props.Amount;
    //   // if at least one of the form values changed
    //   if ( Amount !== nextAmount ) {
    //     this.props.onChange( nextAmount );
    //   }
    // }

    function render() {
      var t = this.props.t;
      var _this$props = this.props,
        _this$props$product = _this$props.product,
        name = _this$props$product.ProductFullName,
        symbol = _this$props$product.ProductSymbol,
        decimalPlaces = _this$props$product.DecimalPlaces,
        handleSubmit = _this$props.handleSubmit,
        invalid = _this$props.invalid,
        submitting = _this$props.submitting,
        onSubmit = _this$props.onSubmit,
        useExternalAddress = _this$props.useExternalAddress,
        toggleUseExternalAddress = _this$props.toggleUseExternalAddress,
        balance = _this$props.balance,
        product = _this$props.product,
        fee = _this$props.fee,
        total = _this$props.total,
        showDetails = _this$props.showDetails,
        disableWithdraw = _this$props.disableWithdraw,
        verificationOnClick = _this$props.verificationOnClick,
        allowTransfer = _this$props.allowTransfer,
        withdrawError = _this$props.withdrawError,
        verificationLevelConfig = _this$props.verificationLevelConfig;
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit(onSubmit),
        className: bemClasses()
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: bemClasses('send-to')
      }, /*#__PURE__*/_react["default"].createElement("header", {
        className: bemClasses('source')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('source-item-with-border')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('source-item', {
          selected: useExternalAddress
        }),
        onClick: function onClick() {
          !useExternalAddress && toggleUseExternalAddress();
        }
      }, t('External Wallet'))), allowTransfer && /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('source-item', {
          selected: !useExternalAddress
        }),
        onClick: function onClick() {
          useExternalAddress && toggleUseExternalAddress();
        }
      }, t('To Email Address')))), disableWithdraw ? /*#__PURE__*/_react["default"].createElement(_VerificationRequiredContainer["default"], {
        disabled: disableWithdraw,
        onClick: verificationOnClick
      }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, useExternalAddress ? /*#__PURE__*/_react["default"].createElement(_SendAddressContainer["default"], {
        product: product,
        balance: balance,
        verificationLevelConfig: verificationLevelConfig
      }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
        className: bemClasses('label-text')
      }, t('Recipient’s Email Address')), /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
        name: "ReceiverUsername",
        customClass: bemClasses(),
        validate: [_formValidations.required, _formValidations.email, this.checkUserEmail]
      })), (!withdrawError || !useExternalAddress) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", {
        className: bemClasses('label-text')
      }, t('Amount of {{name}} to Send', {
        name: name
      })), /*#__PURE__*/_react["default"].createElement("section", {
        className: bemClasses('amounts')
      }, /*#__PURE__*/_react["default"].createElement(_APNumberInput["default"], {
        name: "Amount",
        customClass: bemClasses(),
        labelInInput: symbol,
        decimalPlaces: decimalPlaces,
        allowBigNumber: true,
        validate: [_formValidations.required, allowedAmountValuesRange, this.lessThanBalance]
      }))), !showDetails && /*#__PURE__*/_react["default"].createElement("section", {
        className: bemClasses('info-items')
      }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        label: t('Current Balance:'),
        text: balance,
        customClass: bemClasses()
      }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        label: t('Transaction Fee:'),
        text: fee !== undefined ? fee : '-',
        customClass: bemClasses()
      }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        label: t('Total Amount:'),
        text: total !== undefined ? "".concat(total, " ").concat(symbol) : '-',
        customClass: bemClasses()
      })), !useExternalAddress && /*#__PURE__*/_react["default"].createElement("section", {
        className: bemClasses('note')
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: bemClasses('label-text')
      }, t('Add a Note '), /*#__PURE__*/_react["default"].createElement("em", null, t('(Optional)'))), /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
        name: "Notes",
        rows: 3,
        customClass: bemClasses()
      })), (!withdrawError || !useExternalAddress) && /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        type: "submit",
        customClass: bemClasses(),
        styleName: "additive",
        disabled: invalid || submitting
      }, t('Send'), " ", name)));
    }
  }]);
}(_react["default"].Component);
SendForm.propTypes = {
  product: _sendReceiveComponent.product.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  useExternalAddress: _propTypes["default"].bool.isRequired,
  balance: _propTypes["default"].number.isRequired,
  toggleUseExternalAddress: _propTypes["default"].func.isRequired,
  allowTransfer: _propTypes["default"].bool.isRequired,
  fee: _propTypes["default"].number,
  total: _propTypes["default"].number,
  disableWithdraw: _propTypes["default"].bool,
  verificationOnClick: _propTypes["default"].func
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('send')(SendForm);